/**
 *      ERRORCORRECTIONLEVEL: Error correction level, default: "M"
 *             'L': Low (7%)
 *             'M': Medium (15%)
 *             'Q': Quartile (25%)
 *             'H': High (30%)
 *             http://www.qrcode.com/en/about/error_correction.html
 *      WIDTH: Width (and height) of qr-code measured in px, default: 145px
 *      MARGIN: The margin around the QR code, default: 0
 * 		ARIALABEL: The aria label for the QR Code, default: "QR Code"
 */
export interface QrCodeOptions {
    errorCorrectionLevel?: ErrorCorrectionLevel;
    width?: number;
    margin?: number;
    ariaLabel?: string;
}

type ErrorCorrectionLevel = 'L' | 'M' | 'Q' | 'H';

/**
 * enum that contains the maximum storable characters per quality type.
 * see the chapter about QR Code capacity on https://www.npmjs.com/package/qrcode for more info
 */
export enum MaxChars {
    L = 4296,
    M = 3391,
    Q = 2420,
    H = 1852
}
